'use client';
import React from 'react';
import {
    AccordionContent,
    AccordionItem,
    AccordionRoot,
    AccordionTrigger,
} from '@paypoteam/ui-components';
import parse from 'html-react-parser';

import H2 from '@/components/atoms/Typography/H2';
import Section, { type SectionProps } from '@/components/layout/Section';

import type { AccordionSectionConfigType } from './AccordionSection.types';

export interface AccordionSectionProps extends SectionProps {
    config: AccordionSectionConfigType;
}

const AccordionSection = React.forwardRef<
    HTMLDivElement,
    AccordionSectionProps
>(({ config, className, ...props }, ref) => {
    const { title, accordionContent } = config;

    return (
        <Section
            className={className}
            ref={ref}
            {...props}
        >
            {title ? <H2 className="mb-8 text-center">{title}</H2> : null}

            <AccordionRoot
                type="single"
                collapsible
                className="mx-auto w-auto lg:max-w-[800px]"
            >
                {accordionContent.map(item => (
                    <AccordionItem
                        key={item.id}
                        hover={'color'}
                        value={'FAQ-section-question-' + item.id}
                        data-test-id={'FAQ-section-question-' + item.id}
                    >
                        <AccordionTrigger
                            size="l"
                            className="font-gilroy font-extrabold"
                        >
                            {item.title}
                        </AccordionTrigger>

                        <AccordionContent className="pb-5">
                            {parse(item.content)}
                        </AccordionContent>
                    </AccordionItem>
                ))}
            </AccordionRoot>
        </Section>
    );
});

export default AccordionSection;
